module.exports = __webpack_public_path__ + "static/media/icon-3d-dark.2ddd73b8.svg";